import { prospectTypeEnum } from '../../../enums/prospectTypeEnum'
import { ContactFormValuesEnum } from '../types/contactFormValuesEnum'
import { CivilityEnum } from '../types/civilityEnum'

export const REQUIRED_ACCOUNT_FIELDS: string [] = [
	ContactFormValuesEnum.PROSPECT_TYPE,
	ContactFormValuesEnum.SOCIAL_REASON,
	ContactFormValuesEnum.EMAIL,
	ContactFormValuesEnum.MOBILE,
	ContactFormValuesEnum.ORIGIN
]

export const REQUIRED_CONTACT_FIELDS: string [] = [
	ContactFormValuesEnum.PROSPECT_TYPE,
	ContactFormValuesEnum.CIVILITY,
	ContactFormValuesEnum.FIRSTNAME,
	ContactFormValuesEnum.LASTNAME,
	ContactFormValuesEnum.EMAIL,
	ContactFormValuesEnum.MOBILE,
	ContactFormValuesEnum.ORIGIN
]

export const INITIAL_CREATION_CONTACT = {
	[ContactFormValuesEnum.PROSPECT_TYPE]: prospectTypeEnum.CONTACT,
	[ContactFormValuesEnum.CIVILITY]: CivilityEnum.MONSIEUR
}

export const ERREUR_PROSPECT_DEJA_EXISTANT = 'ERREUR_PROSPECT_DEJA_EXISTANT'